import { render } from "./StoryCard.vue?vue&type=template&id=500d8240&scoped=true"
import script from "./StoryCard.vue?vue&type=script&lang=js"
export * from "./StoryCard.vue?vue&type=script&lang=js"

import "./StoryCard.vue?vue&type=style&index=0&id=500d8240&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-500d8240"

export default script